var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lm-thumbnail"},[_c('section',{staticClass:"lm-thumbnail_content"},[_c('img',{class:['is_block'],attrs:{"src":_vm.src}})]),_c('section',{class:['lm-thumbnail_mock', { 'is_opacity': _vm.visible }]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }